module.exports = __webpack_public_path__ + "static/img/not_found_goods.9ffbe4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/not_found_goods.png
// module id = 01X1
// module chunks = 37